import { combineReducers } from "redux"
import { notifications } from "./notificationsReducer"

const notificationsReducer = combineReducers({
    notifications
})

export default notificationsReducer
